module.exports = __webpack_public_path__ + "static/img/sustainable-performance_02_2025.29cd834.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/csr/sustainable-performance_02_2025.jpg
// module id = A0Ik
// module chunks = 100